export class Aux0ApiError extends Error {
  constructor(
    readonly status: number,
    readonly path: string,
    message: string,
    readonly code: "http" | "network" | "timeout" | "invalid_response" = "http",
  ) {
    super(message);
    this.name = "Aux0ApiError";
  }
}

export class UnavailableDataError extends Error {
  constructor(
    readonly method: string,
    message = "This part of the dashboard is not available yet. Its console API has not been built.",
  ) {
    super(message);
    this.name = "UnavailableDataError";
  }
}
